import script from "./lihatDokumenSIO.vue?vue&type=script&setup=true&lang=js"
export * from "./lihatDokumenSIO.vue?vue&type=script&setup=true&lang=js"

import "./lihatDokumenSIO.vue?vue&type=style&index=0&id=05f205f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05f205f6"]])

export default __exports__